
export const fallBackZones = [
    {
      value: "lounging",
      label: "Living Room",
      img: "/livingRoom.svg",
      visibleOnMakeMagic:true
    },
    {
      value: "lounging,dining",
      label: "Living + Dining",
      img: "/livingRoom.svg",
      visibleOnMakeMagic:true
    },
    {
      value: "dining",
      label: "Dining Room",
      img: "/diningRoom.svg",
      visibleOnMakeMagic:true
    },
    {
      value: "sleeping",
      label: "Bedroom",
      img: "/bedRoom.svg",
      visibleOnMakeMagic:true
    },
    {
      value: "workingvanity",
      label: "Home Office",
      img: "/homeOffice.svg",
      visibleOnMakeMagic:true
    },
    {
      value: "comingandgoing",
      label: "Studio Apartment",
      img: "/images/zones/Cominggoing.svg",
      visibleOnMakeMagic:true
    },
    {
      value: "outdoors",
      label: "Outdoors",
      img: "/images/zones/Cominggoing.svg",
      visibleOnMakeMagic:true
    },
    {
      value: "watchingtv",
      label: "Media Room",
      img: "/images/zones/WatchingTV.svg",
      visibleOnMakeMagic:true
    },
    {
      value: "recreation",
      label: "Rec Room",
      img: "/images/zones/Cominggoing.svg",
      visibleOnMakeMagic:true
    },
    {
      value: "custom",
      label: "Something Else",
      img: "/images/zones/Cominggoing.svg",
      visibleOnMakeMagic:true
    },
  ];

/** Same DB zone values as fallBackZones entries — spliced into partner lists when missing. */
const makeMagicSupplementZones = fallBackZones.filter(
  (zone) => zone.value === "watchingtv" || zone.value === "recreation"
);

/**
 * Make Magic dropdown zones: partner config (or fallBackZones), visible only.
 * Partner lists omit Media Room / Rec Room unless injected after Outdoors.
 */
export function getMakeMagicZones(partnerZones) {
  const usingFallback =
    !Array.isArray(partnerZones) || partnerZones.length === 0;
  const visible = (usingFallback ? fallBackZones : partnerZones).filter(
    (zone) => zone.visibleOnMakeMagic
  );
  if (usingFallback) {
    return visible;
  }

  const missing = makeMagicSupplementZones.filter(
    (sup) => !visible.some((zone) => zone.value === sup.value)
  );
  if (missing.length === 0) {
    return visible;
  }

  const custom = visible.find((zone) => zone.value === "custom");
  const core = visible.filter((zone) => zone.value !== "custom");
  const outdoorsIndex = core.findIndex((zone) => zone.value === "outdoors");
  const insertAt = outdoorsIndex >= 0 ? outdoorsIndex + 1 : core.length;

  return [
    ...core.slice(0, insertAt),
    ...missing,
    ...core.slice(insertAt),
    ...(custom ? [custom] : []),
  ];
}
  
export const fallBackManualItemZones =  [
      { value: "supplementary-popular", label: "Popular" , visibleOnManualItem:true},
      { value: "supplementary-living", label: "Seating", visibleOnManualItem:true },
      { value: "supplementary-storage", label: "Storage" , visibleOnManualItem:true},
      { value: "supplementary-media", label: "Media", visibleOnManualItem:true },
      { value: "supplementary-bedroom", label: "Bedroom" , visibleOnManualItem:true},
      { value: "supplementary-office", label: "Office", visibleOnManualItem:true },
      { value: "supplementary-dining", label: "Dining" , visibleOnManualItem:true},
      { value: "supplementary-rugs", label: "Rugs", visibleOnManualItem:true },
      { value: "supplementary-other", label: "Other" , visibleOnManualItem:true},
]
    